// Unlisted/new terms keep their existing relative order after the saved entries.
export function orderDirectoryTerms(terms, catalog) {
  const ranks = new Map((catalog?.directoryOrder || []).map((id, index) => [id, index]));
  return [...terms].sort((a, b) => (ranks.get(a.id) ?? Infinity) - (ranks.get(b.id) ?? Infinity));
}
